@if (loading()) {
    <div class="state">
        <kendo-loader type="pulsing" size="medium"></kendo-loader>
        <span>{{ "FLIGHT_LIST.images.loading" | translate }}</span>
    </div>
} @else if (failed()) {
    <div class="state">
        <span>{{ "FLIGHT_LIST.images.loadFailed" | translate }}</span>
        <button kendoButton fillMode="flat" themeColor="primary" (click)="load()">{{ "FLIGHT_LIST.retry" | translate }}</button>
    </div>
} @else if (images().length === 0) {
    <div class="state muted">{{ "FLIGHT_LIST.images.none" | translate }}</div>
} @else {
    <div class="gallery">
        @for (image of images(); track image.id) {
            <button type="button" class="tile" [title]="'FLIGHT_LIST.images.open' | translate" (click)="opened.set(image)">
                <img [src]="image.url" alt="" loading="lazy" />
                <span class="caption">
                    @if (image.uploadedBy; as author) {
                        <span class="author">
                            {{ author.name }}
                            <span class="chip" [class]="'author-' + author.type">{{ "FLIGHT_LIST.authors." + author.type | translate }}</span>
                        </span>
                    }
                    <span class="date">{{ image.createdAt | zonedDateTime: timeZone() }}</span>
                </span>
            </button>
        }
    </div>
}

@if (opened(); as image) {
    <kendo-dialog
        [title]="'FLIGHT_LIST.images.uploadedBy' | translate: { name: image.uploadedBy?.name ?? '—', date: (image.createdAt | zonedDateTime: timeZone()) }"
        [maxWidth]="'92vw'"
        [maxHeight]="'92vh'"
        (close)="opened.set(null)"
    >
        <img class="full" [src]="image.url" alt="" />
    </kendo-dialog>
}
